import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { ANALYTICS_BASE_URL, TSDIGITAL_ENDPOINT } from "../../config";
import { Dropdown, Menu, Tooltip } from "antd";
import moment from "moment";
import "./style.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import analyticsRender, {analyticsGetInfo} from "@tsanalytics/widget";
import Chart from "./chart";

import { DATETIME_FORMAT_FOR_DISPLAY } from "../../constants/constants";
import { FormattedMessage, useIntl } from "react-intl";
import {
  getAllBusinessPerformancePermissions,
  getVolDAffariSettings
} from "../../libs/settingsUtils";
import { usePermissions } from "../../customHooks";
import { fixKpiTitle } from "../../libs/lang-utils";
import { GetSelectedCompanyStudio } from "../../libs/companiesUtils";

const MenuItem = Menu.Item;

const AnalyticsChart = props => {
  const {
    anchorId, // serve per poter andare al grafico cliccando in alto sui tab
    childrenList, // figli del grafico padre
    classChart, // classe per il css
    footer, // footer del grafico (es bottone guarda tutte le business performance)
    fromDashCliente,
    fromStatistics, // pagine da cui provengo e per cui devo fare operazioni diverse
    fromObligations,
    fromDeadlines,
    idDivForChart, // id del div da disegnare deve essere univoco
    kpiName, // kpi del grafico. Esempio per il Volume d'affari il kpi è FatturatoFiscaleMensile
    kpiTitle, // Titolo del grafico. Per FatturatoFiscaleMensile è Volume D'affari Mensile, Anno In Corso E Precedente
    metamodel, // true o false ci indica se prendiamo un metamodel disegnato da noi oppure è fatto tutto da analytics.
    parentId, // id del padre del grafico che sto disegnando (se presente)
    addParameter, // parametri aggiuntivi che ci servono (per esempio sulle scadenze da passare al nostro BE)
    customerKpiPermission, // permessi
    kpiType, // tipo di grafico , es 1 numerico
    isCheckup
  } = props;

  // useMergeState serve ad aggiornare lo stato di un oggetto (specie se usato nell'useeffect)
  const useMergeState = initialState => {
    const [state, setState] = useState(initialState);
    const setMergedState = newState =>
      setState(prevState => Object.assign(
        {}, prevState, newState
      ));
    return [state, setMergedState];
  };

  const analytics = useSelector(state => state.analytics);
  const auth = useSelector(state => state.auth);
  const currentPermissions = useSelector(state => state.currentPermissions);
  const main = useSelector(state => state.main);
  const user = useSelector(state => state.user);

  const intl = useIntl();

  const accountantUuidSelected = main.accountantUuidSelected;
  const accountantSelected = main.accountantSelected;
  const studioFind = GetSelectedCompanyStudio();

  const companyUuid = ["DeadlinesInMonthChart","DeadlinesCashFlow"].includes(kpiName) ? main.companyUuidSelected : main.clientIdSelected; // main.companyUuidSelected; // companyUuid o companyId

  const [customerKpiPermissionList, setCustomerKpiPermissionList] = useState(customerKpiPermission ? customerKpiPermission : []);

  const [modal, setModal] = useMergeState({
    content: null,
    visibility: false
  });

  const [chartInfo, setChartInfo] = useMergeState({
    kpi: kpiName ? kpiName : "FatturatoFiscaleMensile",
    title: kpiTitle
      ? kpiTitle
      : intl.formatMessage({id: "customerPage.otherWidget.volumeAffari", defaultMessage: "Volume D'affari Mensile, Anno In Corso E Precedente"})
  });
  const { kpi, title } = chartInfo;

  let displayTitle = title;
  displayTitle = fixKpiTitle(displayTitle);

  const notAvailable = useIntl().formatMessage({ id: "generic.notAvailable" });
  const informations = useIntl().formatMessage({
    id: "customerPage.informations"
  });
  const customerPageNotAvailable = useIntl().formatMessage({
    id: "customerPage.noAvailable"
  });

  const renderGraph = value => {
    const tsditigal_endpoint = TSDIGITAL_ENDPOINT?.replace("/#", "");
    const imagePathNoAuthGraph = `${tsditigal_endpoint}img/analyticsNoAuthGraph.svg`;
    const imagePathNoAuthNumbers = `${tsditigal_endpoint}img/analyticsNoAuthNumbers.svg`;
    const propDiff = !fromStatistics ? "background-size: contain;" : "";
    const condition =
      !fromDashCliente &&
      !fromDeadlines &&
      kpi !== "TotalCostumersChart" &&
      kpi !== "FatturatoFiscaleMensile" &&
      kpi !== "FatturatoFiscaleAnnoInCorsoAnnoPrecedente";
    const buttonShowMore =
      "<table class=\"main\" style=\"border-collapse: separate; width: 100%; background: #ffffff; border-radius: 3px;\">" +
      "<tr><td style=\"width: 100%;display: flex;justify-content: space-between;align-items: center;\"><span style=\"color: rgb(0, 80, 117);font-size: 14px; margin-left:6px;font-weight: normal;letter-spacing: 0px;\">" +
      "" + intl.formatMessage({id: "analytics.cantSeeGraph"}) +  ". </span>" +
      (studioFind?.taxRegion !== "ES" && user?.profile?.language !== "es-ES" ? "<a href=\"#/landing-no-data\" target=\"_self\" style=\"margin-right: -8px;font-family:Roboto;padding:8px;text-align:center;width:150px;height:40px; color: #ffffff;  border-radius: 2px; cursor: pointer; font-size: 16px; border-color: #3498db;background: #0090d1;background-color:#0090d1; background: -moz-linear-gradient(left,  #0090d1 0%, #00c3ea 100%);background: -webkit-linear-gradient(left,  #0090d1 0%,#00c3ea 100%);background: linear-gradient(to right,  #0090d1 0%,#00c3ea 100%);filter: progid:DXImageTransform.Microsoft.gradient( startColorstr=\"#0090d1\", endColorstr=\"#00c3ea\",GradientType=1 );\">" + intl.formatMessage({id: "dashboard.showMore"}) + "</a>" : "") +
      "</td></tr></table>";

    localStorage.setItem("landingAuth", false);

    const authType =
      parseInt(kpiType) === 1 && (childrenList || !fromStatistics)
        ? "<div style=\"color: rgb(193, 193, 196);font-size: 14px; margin-left:16px;font-weight: normal;letter-spacing: 0px;\">" +
        (condition
          ? (intl.formatMessage({id: "analytics.activateToSeeGraph"}) + "</div>")
          : "</div>") +
        "<div id=\"no-auth-chart" +
        kpi +
        "\" style=\"padding:10px;margin:14px;background-size: cover;background-repeat: no-repeat;background-image: url('" +
        imagePathNoAuthNumbers +
        "');\"></div>"
        : "<div style=\"color: rgb(193, 193, 196);font-size: 14px; margin-left:16px;font-weight: normal;letter-spacing: 0px;\">" +
        (condition
          ? (intl.formatMessage({id: "analytics.activateToSeeGraph"}) + "</div>")
          : "</div>") +
        "<div id=\"no-auth-chart" +
        kpi +
        "\" style=\"height:300px;padding:10px;" +
        propDiff +
        "background-repeat: no-repeat;background-position: bottom center;background-image: url('" +
        imagePathNoAuthGraph +
        "');\"></div>";

    const noDataType =
      parseInt(kpiType) === 1 && (childrenList || !fromStatistics)
        ? (!fromDashCliente ? buttonShowMore : "") +
        "<div id=\"no-ghost-chart" +
        kpi +
        "\" style=\"padding:10px;margin-top:30px;margin-left:6px;background-size: cover;background-repeat: no-repeat;background-image: url('" +
        imagePathNoAuthNumbers +
        "');\"></div>"
        : (fromStatistics && childrenList && !fromDashCliente
          ? buttonShowMore
          : "") +
        "<div id=\"no-ghost-chart" +
        kpi +
        "\" style=\"height:300px;padding:10px;" +
        propDiff +
        "background-repeat: no-repeat;background-position: bottom center;background-image: url('" +
        imagePathNoAuthGraph +
        "');\"></div>";

    const authTypeCheckup = "<div style=\"height:300px;padding:10px; background-size: contain; background-repeat: no-repeat;background-position: bottom center;background-image: url('" +imagePathNoAuthGraph + "');\"></div>";

    const noDataTypeCheckup = "<div style=\"height:300px;padding:10px; background-size: contain; background-repeat: no-repeat;background-position: bottom center;background-image: url('" +imagePathNoAuthGraph + "');\"></div>";

    const otpion = {
      // impostazioni di analytics
      showContainer: true,
      showFooter: false,
      showTitle: false,
      // customizzazione dei grafici quando non ho dati o autorizzazione
      customSkin: {
        noData: !isCheckup ? noDataType : noDataTypeCheckup,
        noAuth: !isCheckup ? authType : authTypeCheckup
      },
      widgetEnv: "test",
      lang: user?.profile?.language === "es-ES" ? "es-ES" : "it-IT"
    };
    console.log(otpion);
    const kpiValue = value ? value : kpi;
    if ((!analyticsRender && !analyticsGetInfo) || !kpiValue){
      return null;
    }
    const header = [
      {
        key: "Authorization",
        value: "Bearer " + auth.loginAuth.securityToken
      },
      {
        key: "X-App-Name",
        value: "DIGITALBOXWEB"
      },
      {
        key: "X-Manager-ID",
        value: accountantUuidSelected
          ? accountantUuidSelected
          : accountantSelected
      },
      {
        key: "X-Item-ID",
        value: main.companyUuidSelected
          ? main.companyUuidSelected
          : main.companySelected
      },
      { key: "X-User-ID",
        value: auth.loginAuth.id
      },
      {
        key: "Accept-Language",
        value: otpion?.lang
      }
    ];
    if (addParameter) {
      // servono per passare i dati nei grafici delle scadenze
      header.push(
        {
          key: "X-Reference-Date",
          value: addParameter.date
        },
        {
          key: "X-Reference-Scope",
          value: addParameter.scope ? addParameter.scope : ""
        },
        {
          key: "X-Reference-Archived",
          value: addParameter.archived
        },
        {
          key: "X-Reference-Status",
          value: addParameter.status ? addParameter.status : ""
        }
      );
      if (addParameter.balance) {
        header.push({
          key: "X-Reference-Balance",
          value: addParameter.balance
        });
      }
    }

    // FUNZIONE PRINCIPALE CHE RICHIAMA IL GRAFICO DI ANALYTICS: consultare se serve il kpiviewer https://d32g26lljh6up9.cloudfront.net/widgets/kpiviewer.js
    try {
      analyticsRender({
        disableAnimation: true, // disabilita l'animazione nei grafici
        kpiName: kpiValue, // nome del grafico da disegnare
        fiscalCode: companyUuid, // id dell'azienda
        elementId: idDivForChart, // l'id del div da disegnare
        backend: {
          baseUrl: ANALYTICS_BASE_URL, // url del nostro backend
          headers: header
        }
      }, otpion);
    } catch (e) {
      return null;
    }
    return undefined;
  };

  useEffect(() => {
    if (chartInfo.kpi === "") return;
    renderGraph(typeof kpiName === "undefined" || fromDashCliente ? kpi : kpiName);
  }, [chartInfo, kpiName, auth.loginAuth.securityToken, addParameter?.balance]);

  useEffect(() => {
    // ATTENZIONE: NON RIMUOVERE! Serve per renderizzare le info degli adempimenti
    if (!fromObligations || !window.pubsub) return;
    window.pubsub.subscribe("TeamSystem.widget.renderComplete analyticsObl-chart" + kpi,
      function(event, data) {
        document.getElementById("obl-id").innerHTML = window.dictionaryEval(data.data.metamodel.description);
      });
  }, []);

  useEffect(() => {
    if (
      fromDashCliente &&
      currentPermissions &&
      currentPermissions.permissionClient.status.ended
    ) {
      let analyticsPermissions = [];

      if (isPermissionAnalytics) {
        analyticsPermissions = analyticsPermissions.concat(getAllBusinessPerformancePermissions(currentPermissions));
      }

      if (isPermissionVolDaffari) {
        analyticsPermissions = analyticsPermissions.concat(getVolDAffariSettings(currentPermissions));
      }

      for (let p = 0; p < analyticsPermissions.length; p++) {
        if (analyticsPermissions[p].isActive === true) {
          customerKpiPermissionList.push(analyticsPermissions[p].functionSmallLabel);
        }
      }

      setCustomerKpiPermissionList(customerKpiPermissionList);
    }
  }, [currentPermissions]);

  const changeGraphType = (value, key) => {
    setChartInfo({
      kpi: value,
      title: key
    });
  };

  const isAllRequired = () => {
    return (idDivForChart && companyUuid && analytics) || metamodel;
  };

  const renderInfo = idDiv => {
    try {
      const content = analyticsGetInfo(idDiv);
      console.log(content.description);
      const renderContent = (
        <div style={{ textAlign: "left", maxWidth: "500px" }}>
          <p>
            <b> <FormattedMessage id="analytics.businessPerformance.modalDate" />: </b>
            {content && content.updateDate
              ? moment(content.updateDate, "YYYYMMDDHHmmss").format(DATETIME_FORMAT_FOR_DISPLAY)
              : notAvailable}
          </p>
          <p>
            {content && content.description ? (
              <span dangerouslySetInnerHTML={{ __html: content.description }} />
            ) : (
              <React.Fragment>
                <b>{informations}</b>
                {customerPageNotAvailable}
              </React.Fragment>
            )}
          </p>
        </div>
      );
      setModal({
        content: renderContent,
        visible: true
      });
      return undefined;
    } catch (e) {
      return null;
    }
  };

  const truncate = input =>
    input?.length > 40 ? `${input?.substring(0, 40)}...` : input;

  const renderOption = () => {
    let customOptions = [];
    let titleDefaultKpi = "";

    if (
      analytics &&
      analytics.kpiList &&
      analytics.kpiTitles &&
      analytics.kpiList.data &&
      analytics.kpiTitles.data
    ) {
      const kpiData = analytics.kpiList.data.data;
      const dictionaryTitles = analytics.kpiTitles.data;
      const customertKpiList = [];
      const parentIdList = [];
      for (let amb = 0; amb < kpiData.length; amb++) {
        let kpiCategories = kpiData[amb]["kpiScopes"];
        if (fromDashCliente) {
          // FIND Parent ID
          for (let p = 0; p < kpiCategories.length; p++) {
            // Avendo a disposizione solo il nome del kpi padre Cerco il kpi stesso e se ha un primo figlio
            for (let i = 0; i < kpiCategories[p].kpis.length; i++) {
              const kpiNameCustom = kpiCategories[p].kpis[i].url;
              if (!customerKpiPermissionList.includes(kpiNameCustom)) {
                continue;
              } else {
                // escludo dalla lista i kpi numerici
                parentIdList.push(kpiCategories[p].kpis[i].id);
                if (kpiCategories[p].kpis[i].kpiType.id.toString() === "1") {
                  continue;
                }
                customertKpiList.push(kpiCategories[p].kpis[i]);
              }
            }
            // se ho trovato il primo figlio, cerco se ne ha un secondo
            if (parentIdList.length > 0) {
              for (let k = 0; k < kpiCategories[p].kpis.length; k++) {
                if (
                  kpiCategories[p].kpis[k].parentId !== null &&
                  parentIdList.includes(kpiCategories[p].kpis[k].parentId)
                ) {
                  parentIdList.push(kpiCategories[p].kpis[k].id);
                }
              }
            }
            for (let g = 0; g < kpiCategories[p].kpis.length; g++) {
              if (parentIdList.includes(kpiCategories[p].kpis[g].parentId)) {
                customertKpiList.push(kpiCategories[p].kpis[g]);
              }
            }
          }
        } else {
          for (let p = 0; p < kpiCategories.length; p++) {
            if (
              kpiCategories[p].name === "lynfa.std.studio.name" ||
              kpiCategories[p].name === "sdi.std.statistiche_sdi.name"
            ) {
              continue;
            }
            for (let i = 0; i < kpiCategories[p].kpis.length; i++) {
              if (kpiCategories[p].kpis[i].kpiType.id.toString() === "1") {
                continue;
              }

              const kpiNameCustomUrl = kpiCategories[p].kpis[i].url;

              const analyticsTitleSplit = kpiCategories
                ? kpiCategories[p].kpis[i].title.split(".")
                : [];
              let kpiT = null;
              analyticsTitleSplit.map(el => {
                kpiT = kpiT
                  ? kpiT[el]
                  : dictionaryTitles
                    ? dictionaryTitles[el]
                    : "";
                return kpiT;
              });

              if (!kpiNameCustomUrl) {
                continue;
              }
              const titleTruncate = truncate(kpiT);
              customOptions.push(<MenuItem key={kpiNameCustomUrl}>
                <Tooltip placement="left" title={kpiT} color={"rgb(0, 80, 117)"}>
                  <div
                    onClick={() => changeGraphType(kpiNameCustomUrl, kpiT)}
                  >
                    {" "}
                    <p style={{ wordBreak: "break-all" }}>{titleTruncate}</p>
                  </div>
                </Tooltip>
              </MenuItem>);
            }
          }
        }
      }
      if (fromDashCliente && customertKpiList && customertKpiList.length > 0) {
        for (let q = 0; q < customertKpiList.length; q++) {
          const kpiNameCustomUrl = customertKpiList[q].url;
          const analyticsTitleSplit = customertKpiList[q].title.split(".");
          let kpiT = null;
          analyticsTitleSplit.map(el => {
            kpiT = kpiT
              ? kpiT[el]
              : dictionaryTitles
                ? dictionaryTitles[el]
                : "";
            return kpiT;
          });
          const titleTruncate = truncate(kpiT);
          customOptions.push(<MenuItem key={kpiNameCustomUrl}>
            <Tooltip placement="left" title={kpiT} color={"rgb(0, 80, 117)"}>
              <div onClick={() => changeGraphType(kpiNameCustomUrl, kpiT)}>
                {" "}
                <p style={{ wordBreak: "break-all" }}>{titleTruncate}</p>
              </div>
            </Tooltip>
          </MenuItem>);
          if (
            customerKpiPermissionList &&
            customerKpiPermissionList[0] === kpiName &&
            titleDefaultKpi === ""
          ) {
            titleDefaultKpi = kpiNameCustomUrl;
          }
        }
      }
      if (customOptions && customOptions.length > 0)
        return (
          <Dropdown
            //   onClick={e => e.stopPropagation()}
            overlayClassName={"overlayDropdown"}
            overlay={
              <div style={{ boxShadow: "0px 2px 8px 0px rgba(0, 0, 0, 0.1)" }}>
                <p className="selectStatistics">
                  Seleziona la statistica da mostrare:
                </p>
                <div
                  style={{ flex: " 0 0 auto" }}
                  className="break-divider-horizontal"
                ></div>
                <Menu defaultSelectedKeys={[kpi]}>{customOptions}</Menu>
              </div>
            }
            placement="bottomRight"
            getPopupContainer={trigger => trigger.parentNode}
          >
            <FontAwesomeIcon
              icon={["far", "cog"]}
              style={{ color: "#0090d1", fontSize: "16px", cursor: "pointer" }}
            />
          </Dropdown>
        );
    }
    return undefined;
  };

  let arrayDiv = [];
  if (childrenList) {
    for (let i = 0; i < childrenList.length; i++) {
      arrayDiv.push(<div key={"analyticsView-chart_" + i} style={{ flex: "1 0 auto" }}>
        {!fromObligations && (
          <div
            style={{
              display: "flex",
              padding: "16px"
            }}
          >
            <div style={{ color: "#005075" }}>{childrenList[i].kpiTitle}</div>
            <div>
              <FontAwesomeIcon
                icon={["far", "info-circle"]}
                style={{
                  color: "#0090d1",
                  cursor: "pointer",
                  marginLeft: "10px"
                }}
                onClick={renderInfo.bind(this,
                  "analyticsView-chart" + childrenList[i].kpiName)}
              />
            </div>
          </div>
        )}
        <div
          style={{ height: "350px" }}
          id={"analyticsView-chart" + childrenList[i].kpiName}
        ></div>
      </div>);
    }
  }

  if (
    document.getElementById("analyticsView") &&
    document.getElementById("analyticsView").style
  ) {
    if (
      document.getElementById("analyticsView-chart").innerHTML === "undefined"
    ) {
      document.getElementById("analyticsView").style.visibility = "hidden";
    } else {
      document.getElementById("analyticsView").style.visibility = "visible";
    }
  }
  let className = "";
  if (fromStatistics && !isCheckup) {
    className = "cardSkeleton box1_3 boxStatistics";
  } else if (isCheckup){
    className = "cardSkeleton box1_3 boxStatisticsCheckup";
  } else if (fromObligations) {
    className = "cardSkeleton cardSkeletonGraph" + classChart;
  } else if (!metamodel && fromDashCliente) {
    className = "cardSkeleton box2_3  cardSkeletonGraph" + classChart;
  } else if (!metamodel && !fromDashCliente) {
    className = "cardSkeleton   cardSkeletonGraph" + classChart;
  } else if (
    metamodel &&
    (kpiName === "DeadlinesInMonthChart" || kpiName === "DeadlinesCashFlow")
  ) {
    className = "cardSkeleton  graphDeadlines cardSkeletonGraph" + classChart;
  }
  const titleClassName = !fromStatistics
    ? "titleCard schedaClienteBoxStatistiche"
    : fromObligations
      ? ""
      : "titleCard statistiche";

  const { isPermissionAnalytics } = usePermissions(currentPermissions);

  const { isPermissionVolDaffari } = usePermissions(currentPermissions);

  return isAllRequired() && (parentId === null || parentId === undefined) ? (
    <Chart
      anchorId={anchorId}
      arrayDiv={arrayDiv}
      className={className}
      childrenList={childrenList}
      footer={footer}
      fromObligations={fromObligations}
      fromStatistics={fromStatistics}
      idDivForChart={idDivForChart}
      isPermissionAnalytics={isPermissionAnalytics}
      kpiType={kpiType}
      metamodel={metamodel}
      modal={modal}
      renderInfo={renderInfo}
      renderOption={renderOption}
      title={displayTitle}
      titleClassName={titleClassName}
      setModal={setModal}
    ></Chart>
  ) : null;
};

export default AnalyticsChart;
